// extracted by mini-css-extract-plugin
export default {"stretchedRow":"booking-overview-row_stretchedRow__AEWb2","item":"booking-overview-row_item__YEw3N","divider":"booking-overview-row_divider__H79hj"};